export const homeView: any = {
    easyPayInformationModal: {
      title: 'Pago Directo',
      offerWithoutPromotion: 'Cámbiate hoy a Pago Directo',
      offerWithPromotion: 'Cámbiate hoy y recibe',
      description: 'Es una manera más fácil de realizar el pago de tu suscripción del periódico a El Nuevo Día. Esto te permite realizar tus pagos a través de débito automático a tu cuenta bancaria o a una tarjeta de crédito (VISA, Master Card, Discover o AMEX).',
      offerExplanation: '*Luego de las 4 semanas continuará con su oferta regular.',
      cta: 'Para cambiarte, visita'
    }
  };



// WEBPACK FOOTER //
// /codebuild/output/src4156872633/src/src/app/components/home/home.static.data.ts